import { endpoints } from "config/endpoints.config"
import { GenericResource, IGenericModel, generic } from "models/generic"

interface AgentOperatorData {
  isActive: boolean
  apiToken?: string
  name: string
}

export interface AgentStage {
  id: string
  name: string
  instructions: string
  condition: string
  isActive: boolean
}

export interface AgentMessage extends GenericResource {
  type?: "audio" | "image" | "video" | "file" | "text" | "error"
  content: string
  authorType: "user" | "agent"
  extra?: {
    fileName?: string
    size?: number
    type?: string
  }
  log?: {
    input?: Record<string, any>
    output?: Record<string, any>
    errors?: Record<string, any>
  }
}

export interface IAgent extends GenericResource {
  isEnabled: boolean
  name: string
  instructions?: string
  instructionsHtml?: string
  avatar?: string
  operatorId?: string
  ownerId?: string
  operatorEmail?: string
  apiToken?: string

  temperature?: number
  initialMessage?: string
  model?: string
  maxMessages?: number
  delaySeconds?: number
  description?: string
  knowledgeIds?: string[]
  channelIds?: string[]
  tools?: {
    type: string
    data: Record<string, any>
  }[]
  stages?: AgentStage[]
  engineVersion?: number
  botReferenceId?: string
}

export const agents: IGenericModel<IAgent> = { ...generic(endpoints.AGENT) }
